import { render, staticRenderFns } from "./weborders.vue?vue&type=template&id=23c443e9&"
import script from "./weborders.vue?vue&type=script&lang=js&"
export * from "./weborders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports